import * as ActionTypes from 'state/actions/types'
import * as Selectors from 'state/selectors'

export const exportAnalyticsV2 = ({ dateRange, fileFormat }) => {
  return {
    type: `${ActionTypes.EXPORT_ANALYTICS_V2_REQUEST}_PREPARE`,
    payload: {
      useApiV2: true,
      url: '/analytics.export.druid',
      method: 'get',
      params: {
        dateRange,
        fileFormat
      }
    },
    meta: {
      finalActionType: ActionTypes.EXPORT_ANALYTICS_V2_REQUEST,
      selectorsToPayload: [
        {
          selector: Selectors.getUserEmail,
          deepLevel: [ 'params' ],
          key: 'email'
        },
        {
          selector: Selectors.getActiveAgentId,
          deepLevel: [ 'params' ],
          key: 'agentId'
        }
      ]
    }
  }
}

export const loadExports = () => {
  return {
    type: `${ActionTypes.LOAD_EXPORTS_REQUEST}_PREPARE`,
    payload: {
      useApiV2: true,
      url: '/analytics.exports.list',
      method: 'get',
      params: {}
    },
    meta: {
      finalActionType: ActionTypes.LOAD_EXPORTS_REQUEST,
      selectorsToPayload: [
        {
          selector: Selectors.getActiveAgentId,
          deepLevel: [ 'params' ],
          key: 'agentId'
        }
      ]
    }
  }
}

export const resetExports = () => {
  return {
    type: `${ActionTypes.RESET_EXPORTS_REQUEST}_PREPARE`,
    payload: {
      useApiV2: true,
      url: '/analytics.exports.all',
      method: 'delete',
      data: {}
    },
    meta: {
      finalActionType: ActionTypes.RESET_EXPORTS_REQUEST,
      selectorsToPayload: [
        {
          selector: Selectors.getActiveAgentId,
          deepLevel: [ 'data' ],
          key: 'agentId'
        }
      ],
      meta: {
        successActions: [
          loadExports()
        ]
      }
    }
  }
}

export const deleteExportItem = (exportId) => {
  return {
    type: `${ActionTypes.DELETE_EXPORT_ITEM_REQUEST}_PREPARE`,
    payload: {
      useApiV2: true,
      url: '/analytics.export.item',
      method: 'delete',
      data: {
        exportId
      }
    },
    meta: {
      finalActionType: ActionTypes.DELETE_EXPORT_ITEM_REQUEST,
      selectorsToPayload: [
        {
          selector: Selectors.getActiveAgentId,
          deepLevel: [ 'data' ],
          key: 'agentId'
        }
      ],
      meta: {
        successActions: [
          loadExports()
        ]
      }
    }
  }
}

export const updateReportingConfig = (key, value) => {
  return {
    type: ActionTypes.UPDATE_REPORTING_CONFIG,
    payload: {
      key,
      value
    }
  }
}

export const updateExportApiConfig = (key, value) => {
  return {
    type: ActionTypes.UPDATE_EXPORT_API_CONFIG,
    payload: {
      key,
      value
    }
  }
}
export const updateExportApiAmazonS3Config = (key, value) => {
  return {
    type: ActionTypes.UPDATE_EXPORT_API_AMAZONS3_CONFIG,
    payload: {
      key,
      value
    }
  }
}
export const updateExportApiGoogleConfig = (key, value) => {
  return {
    type: ActionTypes.UPDATE_EXPORT_API_GOOGLE_CONFIG,
    payload: {
      key,
      value
    }
  }
}
export const updateExportApiOBSConfig = (key, value) => {
  return {
    type: ActionTypes.UPDATE_EXPORT_API_OBS_CONFIG,
    payload: {
      key,
      value
    }
  }
}
export const updateExportApiAzureConfig = (key, value) => {
  return {
    type: ActionTypes.UPDATE_EXPORT_API_AZURE_CONFIG,
    payload: {
      key,
      value
    }
  }
}

export const saveReportingConfig = () => {
  return {
    type: `${ActionTypes.SAVE_REPORTING_CONFIG_REQUEST}_PREPARE`,
    payload: {
      useApiV2: true,
      url: '/analytics.reporting.config.save',
      method: 'post',
      data: {}
    },
    meta: {
      finalActionType: ActionTypes.SAVE_REPORTING_CONFIG_REQUEST,
      selectorsToPayload: [
        {
          selector: Selectors.getReportingConfig,
          deepLevel: [ 'data' ],
          key: 'reportingConfig'
        },
        {
          selector: Selectors.getActiveAgentId,
          deepLevel: [ 'data' ],
          key: 'agentId'
        }
      ]
    }
  }
}

export const fetchReportingConfig = () => {
  return {
    type: `${ActionTypes.FETCH_REPORTING_CONFIG_REQUEST}_PREPARE`,
    payload: {
      useApiV2: true,
      url: '/analytics.reporting.config.fetch',
      method: 'get',
      params: {}
    },
    meta: {
      finalActionType: ActionTypes.FETCH_REPORTING_CONFIG_REQUEST,
      selectorsToPayload: [
        {
          selector: Selectors.getActiveAgentId,
          deepLevel: [ 'params' ],
          key: 'agentId'
        }
      ]
    }
  }
}

export const saveExportApiConfig = () => {
  return {
    type: `${ActionTypes.SAVE_EXPORT_API_CONFIG_REQUEST}_PREPARE`,
    payload: {
      useApiV2: true,
      url: '/analytics.export.api.config.save',
      method: 'post',
      data: {}
    },
    meta: {
      finalActionType: ActionTypes.SAVE_EXPORT_API_CONFIG_REQUEST,
      selectorsToPayload: [
        {
          selector: Selectors.getExportApiConfig,
          deepLevel: [ 'data' ],
          key: 'exportApiConfig'
        },
        {
          selector: Selectors.getActiveAgentId,
          deepLevel: [ 'data' ],
          key: 'agentId'
        },
        {
          selector: Selectors.getActiveOrganisationId,
          deepLevel: [ 'params' ],
          key: 'organisationId'
        }
      ]
    }
  }
}

export const fetchExportApiConfig = () => {
  return {
    type: `${ActionTypes.FETCH_EXPORT_API_CONFIG_REQUEST}_PREPARE`,
    payload: {
      useApiV2: true,
      url: '/analytics.export.api.config.fetch',
      method: 'get',
      params: {}
    },
    meta: {
      finalActionType: ActionTypes.FETCH_EXPORT_API_CONFIG_REQUEST,
      selectorsToPayload: [
        {
          selector: Selectors.getActiveAgentId,
          deepLevel: [ 'params' ],
          key: 'agentId'
        },
        {
          selector: Selectors.getActiveOrganisationId,
          deepLevel: [ 'params' ],
          key: 'organisationId'
        }
      ]
    }
  }
}

export const closeExportErrorModal =() =>{
  return {
    type: ActionTypes.CLOSE_EXPORT_ERROR_MODAL
  }
}